import { render, staticRenderFns } from "./TransMoveAddDialog.vue?vue&type=template&id=05537341&scoped=true"
import script from "./TransMoveAddDialog.vue?vue&type=script&lang=js"
export * from "./TransMoveAddDialog.vue?vue&type=script&lang=js"
import style0 from "./TransMoveAddDialog.vue?vue&type=style&index=0&id=05537341&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05537341",
  null
  
)

export default component.exports